module.exports = require("./src/gatsby/browser.tsx");
